<template>

  <!-- <b-modal
    size="lg"
    v-model="isVisible"
    hide-footer
    @hidden="onHidden"
  > -->

  <ModalContainer queryParam="cld" ref="modalContainer" size="lg">
    <b-card>
      <h3 class="text-center">Check List Documental</h3>


      <div class="row my-1" v-if="dataProceso">
        <div class="col-12">
          <b>Paciente:</b> {{ dataProceso.paciente }}</div>
        <div class="col-12">
          <b>Procedimiento:</b> {{ dataProceso.procedimiento }}</div>
      </div> 


      <div>
        <hr>
        <h4 class="text-center">Valoracion Prequirurgicas</h4>

        <div class="d-flex justify-content-end">
          <b-button
            v-if="!showFormTemp"
            variant="warning"
            @click="showFormTemp = true"
            size="sm"
          >Anadir valoracion</b-button>

        </div>

        <div v-if="showFormTemp">
          <div class="mb-1">
            <label for="">Especialista: </label>
            <SearchOpts 
              v-model="temporal.doctor"
              :searchService="getDoctoresByEstablecimiento"
              :omit="omitDoctores"
            />
          </div>
          

          <div class="d-flex align-items-center mb-1">
            <label for="">Paciente apto</label>
            <b-form-checkbox
              class="ml-2"
              switch
              v-model="temporal.pacienteApto"
            >{{ temporal.pacienteApto ? "Si" : "No" }}</b-form-checkbox>
          </div>
          
          <div>
            <label for="">Observaciones y Recomendaciones</label>
            <b-form-textarea v-model="temporal.observaciones"></b-form-textarea>
          </div>

          <div class="d-flex justify-content-end mt-2">
            <b-button
              variant="danger"
              size="sm"
              @click="showFormTemp = false"
            >X Cancelar</b-button>

            <b-button 
              class="ml-2"
              variant="primary" 
              size="sm"
              @click="addValoracionesList"
              :disabled="disabledAddList"
            >+ Agregar</b-button>
          </div>
        </div>
        
      </div>


      <div>
        <b-table
          v-if="cld.valoracionesList.length"
          class="mt-3"
          :items="cld.valoracionesList"
          :fields="fieldsTable"
        >
          <template #cell(pacienteApto)="data">
            {{ data.item.pacienteApto ? "Si" : "No" }}
          </template>
        </b-table>

        <EmptyResults
          v-if="!cld.valoracionesList.length"
          message="No se han registrado valoraciones"
          size="sm"
        />
        
      </div>
      
      <div class="row mt-3">

        <div class="col-5">

          <div class="row d-flex align-items-center mt-1">
            <label class="col-6">Resultados de laboratorio</label>
            <b-form-checkbox 
              v-model="cld.resultadosLaboratorio"
              switch
              class="ml-2"
            >
              {{ cld.resultadosLaboratorio ? "Si" : "No" }}
            </b-form-checkbox> 
          </div> 

          <div class="row d-flex align-items-center mt-1">
            <label class="col-6">Informe de imagenes</label>
            <b-form-checkbox 
              v-model="cld.informeImagenes"
              switch
              class="ml-2"
            >
              {{ cld.informeImagenes ? "Si" : "No" }}
            </b-form-checkbox> 
          </div> 

          <div class="row d-flex align-items-center mt-1">
            <label class="col-6">Informe de EKG</label>
            <b-form-checkbox 
              v-model="cld.informeEkg"
              switch
              class="ml-2"
            >
              {{ cld.informeEkg ? "Si" : "No" }}
            </b-form-checkbox> 
          </div> 
        </div>


        <div class="col-7">
          <label for="">Auxiliar</label>

          <SearchOpts 
            v-model="cld.auxiliar"
            :searchService="getAuxiliarMedicoByEstablecimiento"
            placeholder="Buscar auxiliar..."
          />

        </div>

        <div class="col-12 mt-2">
          <label>Observaciones Generales</label>
          <b-form-textarea
            v-model="cld.observacionesGenerales"
          />
        </div> 
        
      </div>


      <div class="d-flex justify-content-end mt-2">
        <b-button
          variant="success"
          @click="onSaveCld"
        > 
          <i class="fas fa-save"/>
          Guardar
        </b-button>
      </div>

    </b-card>
  </ModalContainer>
  
</template>

<script>
import { SearchOpts, EmptyResults } from '@/shared/components';
import { doctoresService }          from "@/shared/services";
import { getEstablecimientoLS }     from '@/shared/helpers';
import { auxiliarMedicoService } from '../../../administracion/services';
import { procedimientosFormulariosService } from '../../services/procedimientosFormulariosService';
import { ModalContainer } from '../../../../shared/components';

export default {

  name: "FormCld",

  props: {
    metaData:{
      type: Object,
      default: null
    }
  },

  components: {
    SearchOpts,
    EmptyResults,
    ModalContainer
  },

  created(){
    this.getData()
  },

  data(){
    return{
      tokenFormulario:null,
      tokenProceso: null,
      isVisible: false,
      showFormTemp: false,

      idRegistroForm: null,

      temporal:{
        doctor: null,
        pacienteApto: false,
        observaciones:''
      },

      cld:{
        auxiliar: null,
        resultadosLaboratorio: false,
        informeImagenes: false,
        informeEkg: false,
        observacionesGenerales: null,
        valoracionesList:[],
      },

      fieldsTable: [
        { key: "doctor.text",       label: "Especialista" },
        { key: "doctor.especialidad", label: "Especialidad" },
        { key: "pacienteApto",        label: "Paciente apto" },
        { key: "observaciones",       label: "Observaciones y Recomendaciones" },
      ]
    }
  },

  methods: {
    async getData(){

      this.tokenProceso = this.$route.query.forms;
      this.tokenFormulario = this.$route.query.cld
      if(!this.tokenProceso) return;
      
     const response = await procedimientosFormulariosService.obtenerFormProcDataByToken(this.tokenFormulario);

      this.messageAlert = {
          text: 'Informacion por registrar',
          variant: 'info'
        };
      
      if(!response) {
     
        return
      }
      let paciente = `${response.procedimientoCita.consultamedica.cita.paciente.persona.primerApellido} ${response.procedimientoCita.consultamedica.cita.paciente.persona.primerNombre} `

      

      this.messageAlert = {
        text:"Info cargada",
        variant:"success"
      };

      let dataForm = null
      try{
        dataForm = JSON.parse(response.dataJson)
      }catch(error){console.log("Eror", error)}

      
      
      this.cld = dataForm;

      this.isVisible = true;
    },


    async onSaveCld(){
      const jasonCld = JSON.stringify(this.cld);

      const params = {
        tokenProceso   : this.tokenProceso,
        tokenFormulario: this.tokenFormulario,
        dataJson       : jasonCld,
        nameForm       : 'cld',
        idRegistroForm : this.idRegistroForm
      }

      const responseSave = await procedimientosFormulariosService.guardarData(params);

      if(!responseSave){
        console.error('error al guardar');
        return;
      }

      await this.$swal("Formulario guardado.", "", "success");
      this.$emit("formulario-guardado");
      this.isVisible = false;
    },


    async getDoctoresByEstablecimiento(search){
      const establecimiento = getEstablecimientoLS();
      const responseDoctores = await doctoresService.searchDoctoresByTermSelect(search, establecimiento.id);

      const responseMap = responseDoctores.map(item => ({
        value: item.value,
        text: item.text,
        especialidad: item.especialidad
      }));

      return responseMap;
    },


    async getAuxiliarMedicoByEstablecimiento(search){
      const establecimiento = getEstablecimientoLS();

      const params = {
        search,
        establecimiento: establecimiento.id
      } 

      const responseAux = await auxiliarMedicoService.getAll(params);
      const auxiliares = responseAux?.auxiliares;

      const responseMap = auxiliares.map(item => ({
        value: item.id,
        text: item.text,
      }));

      return responseMap;
    },


    addValoracionesList(){

      this.cld.valoracionesList.push(this.temporal);

      this.temporal = {
        doctor: null,
        pacienteApto: false,
        observaciones:''
      };

      this.showFormTemp = false;
    },

    onHidden() {
      this.isVisible = false;
    },
  },
  props: {
   
    dataProceso: {
      required:false,
      default:null,
    }
  },


  computed:{

    disabledAddList(){
      return !this.temporal.doctor
    },

    omitDoctores(){
      return this.cld.valoracionesList.map( 
        m => ({ id: m.doctor.value })
      );
    }
  },

  watch: {

    '$route.query.cld': {
      handler(newValue){
        if(newValue){
        this.getData();
      }
    }
    },


    isVisible: {
      deep: true,
      handler(newValue) {
        if (!newValue) {
          const updatedQuery = { ...this.$route.query };
          delete updatedQuery.cld;
          this.$router.push({ path: this.$route.path, query: updatedQuery });
        }
      }
    }
  }
}
</script>
